<template>
    <q-form ref="projectForm" @submit.prevent="saveProject(form)"
        :data-component-name="$options.name"
    >
        <div class="o-row -gutter-md -form-flex-wrapper"  v-if="form">
            <div class="o-col w-1/4" style="width: 23%; padding-top: 31px;">
                <!-- <q-tabs v-model="projectTabs" dense class="c-form-tabs" align="justify">
                    <q-tab name="projectTabs" label="Projet" />
                </q-tabs>
                <q-separator class="q-mb-md" /> -->
                <!-- <h4 class="o-project-form__title">Description générale</h4> -->

                <input v-model="form.id" type="hidden">
                <div class="o-form__item"><!--{{userRole}} {{ accessLevel }}-->
                    <Input v-model="form.contract_number" label="No de contrat"/>
                </div>
                <div class="o-form__item">
                    <Input v-model="form.name" label="Nom du projet *" required=true />
                </div>
                <div class="o-form__item q-mb-lg">
                    <Input type="textarea" v-model="form.description" label="Description du projet" autogrow />
                </div>
                <div class="o-form__item">
                    <UserProfileInput
                        v-model="form.projectManager"
                        label="Chargé de projet"
                        :variables="projectManagerRoles"
                    />
                </div>
                <div class="o-form__item">
                    <UserProfileInput
                        v-model="form.supervisor"
                        label="Superviseur des travaux"
                    />

                </div>
                <div class="o-form__item q-mb-lg">
                    <ProjectCategoryInput
                        v-model="form.projectCategories"
                        label="Catégories de projet"
                        :multiple="true"
                    />
                    <!-- {{ form.projectCategories}} -->
                </div>
                <div class="o-form__item">
                    <CustomerInput
                        v-model="form.customers"
                        :multiple="true"
                        label="Clients"
                        :variables="null"
                        forceType="Customer"
                    />
                </div>
                <div class="o-form__item">
                    <ContactInput
                        v-model="form.contacts"
                        :multiple="true"
                        label="Contact client"
                        :variables="customerVariables"
                        forceType="CustomerContact"
                    />
                </div>
                <div class="o-form__item q-mb-lg">
                    <LocationInput
                        v-model="form.locations"
                        :multiple="true"
                        label="Lieu de rassemblement"
                        :variables="customerVariables"
                        forceType="CustomerLocation"
                    />
                </div>
                <div class="o-form__item">
                    <Input v-model="form.externalID" label="ID Externe" />
                </div>
                <div class="o-form__item">
                    <Input v-model="form.workforce_request_number" label="# demande de main d'œuvre" />
                </div>
                <div class="o-form__item q-mb-lg">
                    <Input v-model="form.workforce_change_number" label="# changement de main d'œuvre" />
                </div>

                <div class="o-form__item" v-show="form.start_date">
                    <Input
                        v-model="form.start_date"
                        label="Date de début"
                        readonly
                    />
                </div>
                <div class="o-form__item" v-show="form.end_date">
                    <Input
                        v-model="form.end_date"
                        :value="minMaxDates.max"
                        label="Date de fin"
                        readonly
                    />
                </div>
                <div :key="tg" v-for="(tagGroup, tg) in customTagsList">
                    <div class="o-form__item" v-if="customTagsList.length>0">
                        <q-field
                            filled
                            dense
                            placehoder="Non assigné"
                            :label="tagGroup.label"
                            value="none"
                            icon="add"
                            :bottom-slots="false"
                            class="custom-input-list"
                        >
                            <template v-slot:control>
                                <div class="q-field__native items-center full-width input-row" tabindex="0"
                                    :key="t"
                                    v-for="(tag, t) in tagGroup.tags"
                                >
                                    <div>
                                        {{ tag.name }}
                                    </div>
                                    <q-icon
                                        class="q-field__focusable-action material-icons q-icon notranslate"
                                        size="xs"
                                        name="cancel"
                                        @click="removeProjectCustomTag(tag)"
                                    />
                                </div>
                            </template> 
                        </q-field>
                    </div>
                </div>

                <!-- <div class="o-form__item">
                    <ModelCustomTagsMenu 
                        @add-custom-tag="addProjectCustomTag($event)"
                        tagsModel="PROJECTS"
                        icon-right="add"
                        label="Informations complémentaires"
                        size="sm"
                    />
                </div> -->


            </div>
            <div class="o-col w-1/4 q-pt-sm" style="width: 23%; padding-top: 19px;">
                <!-- <q-tabs v-model="projectShiftTabs" dense class="c-form-tabs" align="justify">
                    <q-tab name="projectShiftTabs" label="Quarts de travail" />
                </q-tabs>
                <q-separator class="q-mb-md" /> -->
                <!-- <span><h4 class="o-project-form__title">Quarts de travail</h4></span> -->
                <div class="row align-items-center">
                    <ShiftTemplatesList
                        :weekrange="weekrange"
                        @set-new-shift="setNewProjectShift($event)"
                    />
                    <span class="q-ml-auto row align-items-center">
                        <q-btn icon="filter_list" size="sm" dense title="Trier par date"
                            @click="orderBySort = orderBySort === 'ASC' ? 'DESC' : 'ASC'" :class="{ 'rotate-180': orderBySort !== 'DESC' }" />
                    </span>
                </div>
                <q-list class="c-project-shift-list q-mt-md">
                    <div
                        v-for="(projectShift) in projectShifts"
                        :key="'projectShift-' + projectShift.id"
                        @click="selectedProjectShift=projectShift"
                        :class="{ 'selected': selectedProjectShift && projectShift.id == selectedProjectShift.id }"
                    >
                        <ProjectShift
                            :accessLevel="accessLevel"
                            :weekrange="weekrange"
                            :project="project"
                            :projectShift="projectShift"
                            :selectedProjectShift="selectedProjectShift"
                            :expanded="selectedProjectShift && projectShift.id == selectedProjectShift.id"
                            @read-mode="selectedProjectShift=$event"
                            @remove-projectshift="removeProjectShift($event)"
                            @duplicate-projectshift="duplicateProjectShift($event)"
                            :projectShiftWithError="projectShiftWithError"
                            :projectShiftWithUnassigned="projectShiftWithUnassigned"
                            @clear-selectedShift="selectedProjectShift=null"
                            @set-ressource-tab-active="assignmentsTabs='resources'"
                            :customerVariables="customerVariables"
                        />
                    </div>
                </q-list>
                <template v-if="!isValid && !projectShifts.length">
                    <q-item-section class="text-negative">
                        Vous devez ajouter au moins un quart de travail
                    </q-item-section>
                </template>
            </div>
            <div class="o-col w-1/4 c-assignments-col" :style="(!$generalSettings.settings.enableAccommodationModule && !$generalSettings.settings.enableResourceModule)? 'width: 29%; padding-top : 19px;':'width: 29%; padding-top: 15px;'">
                <!-- <h4 class="o-project-form__title">Détails du quart de travail</h4> -->
                <div v-if="selectedProjectShift && selectedProjectShift.id!=-1">
                    <template v-if="$generalSettings.settings.enableAccommodationModule || $generalSettings.settings.enableResourceModule">
                        <q-tabs v-model="assignmentsTabs" dense class="c-form-tabs"  align="justify">
                            <q-tab name="assignments" alert-icon="hourglass_bottom">
                                <div class="q-tab__label row align-items-center">
                                    Affectations
                                    <span>
                                        <q-badge style="position: static; display: inline-block; padding-top: 3px;" color="grey-5 q-ml-sm" v-if="selectedProjectShift.projectAssignments.length">{{ selectedProjectShift.projectAssignments.length }}</q-badge>
                                    </span>

                                    <span v-if="projectShiftWithError[selectedProjectShift.id]">
                                        <q-icon class="o-item-with-warning-icon q-ml-xs" color="red" name="error" size="14px">
                                            <q-tooltip>
                                                Cet onglet contient des erreurs.
                                            </q-tooltip>
                                        </q-icon>
                                    </span>
                                    <span v-if="selectedProjectShift.hasUnpublishedShift || selectedProjectShift.projectAssignments.some(assignment => assignment.hasDraft)">
                                        <q-icon class="o-item-with-warning-icon q-ml-xs" name="hourglass_bottom" size="14px">
                                            <q-tooltip>
                                                Cet onglet contient des informations non publiées.
                                            </q-tooltip>
                                        </q-icon>
                                    </span>
                                </div>
                            </q-tab>
                            <q-tab name="accommodation" v-if="$generalSettings.settings.enableAccommodationModule">
                                <div class="q-tab__label row">
                                    Hébergement / Hôtel
                                    <span>
                                        <q-badge style="position: static; display: inline-block; padding-top: 3px;" color="grey-5 q-ml-sm" v-if="accommodationErrors.sucessCount">{{ accommodationErrors.sucessCount }}</q-badge>
                                        <q-badge style="position: static; display: inline-block; padding-top: 3px;" color="red q-ml-sm" v-if="accommodationErrors.errorCount">{{ accommodationErrors.errorCount }}</q-badge>
                                    </span>
                                </div>
                            </q-tab>
                            <q-tab name="resources" v-if="$generalSettings.settings.enableResourceModule">
                                <div class="q-tab__label row">
                                    Ressources
                                    <span>
                                        <q-badge style="position: static; display: inline-block; padding-top: 3px;" color="grey-5 q-ml-sm" v-if="selectedProjectShiftResourceCount">{{ selectedProjectShiftResourceCount }}</q-badge>
                                    </span>

                                    <span
                                        v-if="projectShiftWithError[('resource'+selectedProjectShift.id)]">
                                        <q-icon class="o-item-with-warning-icon q-ml-xs" color="red" name="error" size="14px">
                                            <q-tooltip>
                                                Cet onglet contient des erreurs.
                                            </q-tooltip>
                                        </q-icon>
                                    </span>
                                    <span
                                        v-if="selectedProjectShift.resources.some(resource => (resource.pivot) ? resource.pivot.hasDraft : true)">
                                        <q-icon class="o-item-with-warning-icon q-ml-xs" name="hourglass_bottom" size="14px">
                                            <q-tooltip>
                                                Cet onglet contient des informations non publiées.
                                            </q-tooltip>
                                        </q-icon>
                                    </span>

                                </div>
                            </q-tab>
                            <!-- <q-tab name="resources" label="Ressources" disabled />
                            <q-tab name="more" label="Autres" disabled /> -->
                        </q-tabs>
                        <q-separator class="q-mb-sm" />
                    </template>
<!-- {{ projectAssignmentWithError }} -->
                    <q-tab-panels v-model="assignmentsTabs" animated>

                        <q-tab-panel name="assignments" class="q-px-none q-pt-sm">
                            <div class="q-pb-sm">
                                <q-btn-group spread>

                                        <DropdownButton
                                            :options="professions"
                                            @input="addAssignement($event)"
                                            outline
                                            label="Métiers"
                                            icon="add_circle"
                                        />
                                        <DropdownButton
                                            :options="skills"
                                            @input="addTagVariant($event, 'skills')"
                                            label="Compétences"
                                            outline
                                            icon="add_circle"
                                            color="warning"
                                        />
                                        <DropdownButton
                                            :options="courses"
                                            @input="addTagVariant($event, 'courses')"
                                            label="Formations"
                                            outline
                                            icon="add_circle"
                                            color="positive"
                                        />
                                    </q-btn-group>
                                </div>
                                <div>
                                    <TagsList
                                    :tags="selectedProjectShift.skills"
                                    color="warning"
                                    />
                                    <TagsList
                                        :tags="selectedProjectShift.courses"
                                        color="positive"
                                        />
                                </div>
                                <AssignmentsList
                                    :accessLevel="accessLevel"
                                    :variables="bestCandidateVariables"
                                    :assignments="selectedProjectShift.projectAssignments"
                                    :projectAssignmentWithError="projectAssignmentWithError"
                                    @remove-assignment="removeAssignment($event)"
                                    @unassign="unassign($event)"
                                    @set-assignments-count="setAssignmentsCount($event)"
                                />
                        </q-tab-panel>

                        <q-tab-panel name="accommodation" class="q-px-none q-pt-sm c-accommodation">
                            <div class="q-pb-sm q-pt-xs">
                                <div class="o-form__item q-pt-md">
                                    <AccommodationsInput
                                        v-model="selectedProjectShift.accommodations"
                                        :multiple="false"
                                        label="Hébergement / Hôtel"
                                        :variables="null"
                                        forceType="Accommodation"
                                    />
                                </div>
<!-- <pre>{{ form }}</pre> -->
<!-- {{ selectedProjectShift.accommodations }} -->
                                <div class="o-form__item q-pt-md">
                                    <AssignmentsAccommodationList
                                        v-if="selectedProjectShift.accommodations && (selectedProjectShift.accommodations.length || selectedProjectShift.accommodations.id)"
                                        :accessLevel="accessLevel"
                                        :variables="bestCandidateVariables"
                                        :assignments="selectedProjectShift.projectAssignments"
                                        :projectAssignmentWithError="projectAssignmentWithError"
                                        @remove-assignment="removeAssignment($event)"
                                        @unassign="unassign($event)"
                                        @set-assignments-count="setAssignmentsCount($event)"
                                    />
                                </div>
                            </div>
                        </q-tab-panel>
                        <q-tab-panel name="resources" class="q-px-none q-pt-sm c-resources">
                            <div class="q-pb-sm">
                                <!-- {{ availableStaffVehicules }} -->
                                <div class="o-form__item">
                                    <ResourceTrackingInput
                                        :accessLevel="accessLevel"
                                        :resource="null"
                                        @input="addResource($event)"
                                        :variables="bestCandidateVariables"
                                        :availableStaffVehicules="availableStaffVehicules"
                                        :isButton="'Ajouter une ressource'"
                                    ></ResourceTrackingInput>
                                </div>
<!-- {{ selectedProjectShift }} -->

                                <div class="o-form__item">
                                    <ResourcesTrackingList
                                        :accessLevel="accessLevel"
                                        :variables="bestCandidateVariables"
                                        :resources="selectedProjectShift.resources"
                                        :staffVehicules="selectedProjectShift.staffVehicules"
                                        :availableStaffVehicules="availableStaffVehicules"
                                        :projectAssignmentWithError="projectAssignmentWithError"
                                        :projectShiftId="selectedProjectShift.id"
                                        @remove-resource="removeResource($event)"
                                        @unassign="unassign($event)"
                                        @set-resources-count="setResourcesCount($event)"
                                        @update-resource="updateResource($event)"
                                    >
                                    </ResourcesTrackingList>
                                </div>
                            </div>
                        </q-tab-panel>
                    </q-tab-panels>                    
                </div>
                <!-- <div v-if="!selectedProjectShift" class="q-pt-xl">Aucun quart de travail sélectionné</div> -->
            </div>
            <!-- <div class="o-col w-1/4 -project-form-notif">
                <div class="c-notifications -project-form tempNotifList">
                    <Notifications 
                        :projectID="form.id"
                        currentTab="currentTab"
                        ref="HistoryPanel"
                        v-if="form.id>0"
                        @set-current-tab="currentTab=$event"
                     />
                </div>
            </div> -->
            <div class="o-col w-1/4 -project-form-notif">
                <!-- <div class="c-notifications -project-form tempNotifList"> -->
                    <Notifications 
                        :projectID="form.id"
                        :parentProject="form"
                        :internalNote="project.internal_notes"
                        currentTab="currentTab"
                        ref="HistoryPanel"
                        v-if="form.id>0"
                        @set-current-tab="currentTab=$event"
                        @set-current-date="$emit('set-current-date', $event)"
                        @internalnote:change="saveInternalNotes($event)"
                      />
                <!-- </div> -->
            </div>



        </div>
        <div class="o-row form-buttons" v-if="form">
            <div class="o-col w-1/2">
                <q-btn
                    color="white"
                    text-color="blue"
                    icon-right="close"
                    size="sm"
                    class="q-mr-md"
                    rounded
                    no-caps
                    label="Fermer"
                    @click.stop="$emit('cancel')"
                />

                <ModelCustomTagsMenu 
                    @add-custom-tag="addProjectCustomTag($event)"
                    tagsModel="PROJECTS"
                    color="white"
                    text-color="blue"
                    icon-right="playlist_add"
                    size="sm"
                    class="button q-mr-md"
                    rounded
                    no-caps
                />
                <q-btn
                    color="white"
                    text-color="grey"
                    icon-right="more_horiz"
                    size="sm"
                    class="button q-mr-md"
                    rounded
                    no-caps
                >
                    <q-menu>
                        <q-list separator bordered style="min-width: 100px">
                            <div>
                                <q-item clickable
                                    @click="sendProjectNotifications(form)"
                                    v-close-popup
                                    :disable="form.id > 0 && form.hasNotificationsReady && !gotModified ? false : true"
                                    v-if="form.id > 0 && userRole == 'ADMINISTRATOR'"
                                    class="q-pa-md"
                                >
                                    <q-item-section thumbnail class="q-px-md">
                                        <q-icon name="send" size="xs"/>
                                    </q-item-section>
                                    <q-item-section>Envoyer les notifications aux employés</q-item-section>
                                </q-item>
                                <q-separator v-if="form.id > 0 && userRole == 'ADMINISTRATOR'"/>
                                <q-item clickable
                                    @click="sendPartnerProjectNotifications(form)"
                                    v-close-popup
                                    :disable="form.id > 0 && form.hasPartnerNotificationsReady && !gotModified ? false : true"
                                    v-if="form.id > 0 && userRole == 'ADMINISTRATOR'"
                                    class="q-pa-md"
                                >
                                    <q-item-section thumbnail class="q-px-md">
                                        <q-icon name="send" size="xs"/>
                                    </q-item-section>
                                    <q-item-section>Envoyer les notifications aux partenaires</q-item-section>
                                </q-item>
                                <q-separator v-if="form.id > 0 && userRole == 'ADMINISTRATOR'"/>

                                <q-item clickable 
                                    @click="revertProject()"
                                    v-close-popup
                                    :disable="gotModified ? false : true"
                                    v-if="form.id>0 && form.status!='ARCHIVED'"
                                    class="q-pa-md"
                                >
                                    <q-item-section thumbnail class="q-px-md">
                                        <q-icon name="undo" size="xs" />
                                    </q-item-section>
                                    <q-item-section>Annuler les changements</q-item-section>
                                </q-item>
                                <q-separator v-if="form.id > 0 && form.status != 'ARCHIVED'"/>

                                <q-item clickable 
                                    v-if="form.id>0 && form.status=='ARCHIVED' && userRole=='ADMINISTRATOR'"
                                    @click="saveProject(form)"
                                    class="q-pa-md"
                                >
                                    <q-item-section thumbnail class="q-px-md">
                                        <q-icon name="archive" size="xs" />
                                    </q-item-section>
                                    <q-item-section>Restaurer le projet</q-item-section>
                                </q-item>
                                <q-separator v-if="form.id > 0 && form.status == 'ARCHIVED' && userRole == 'ADMINISTRATOR'"/>

                                <q-item clickable 
                                    v-if="form.id>0 && form.status=='ARCHIVED' && userRole=='ADMINISTRATOR'"
                                    @click="confirmDelete=true"
                                    class="q-pa-md"
                                >
                                    <q-item-section thumbnail class="q-px-md">
                                        <q-icon color="red" name="delete" size="xs" />
                                    </q-item-section>
                                    <q-item-section style="color:red">
                                        Supprimer le projet
                                    </q-item-section>
                                </q-item>
                                <q-separator v-if="form.id > 0 && form.status == 'ARCHIVED' && userRole == 'ADMINISTRATOR'"/>

                                <q-item clickable @click="saveProject(form)"
                                    :disable="(apolloLoading) ? true : false"
                                    v-if="form.id>0 && form.status!='ARCHIVED'"
                                    class="q-pa-md"
                                >
                                    <q-item-section thumbnail class="q-px-md">
                                        <q-icon name="save" size="xs" />
                                    </q-item-section>
                                    <q-item-section>Forcer sauvegarder</q-item-section>
                                </q-item>
                                <q-separator v-if="form.id > 0 && form.status != 'ARCHIVED'"/>
                                <!-- <q-item clickable @click="saveProject(form, true)"
                                    :disable="(apolloLoading) ? true : false"
                                    v-if="form.id>0 && form.status!='ARCHIVED'"
                                >
                                    <q-item-section>Forcer sauvegarder (debug)</q-item-section>
                                </q-item> -->
                                <q-item clickable @click="publishShifts(form)"
                                    :disable="(apolloLoading) ? true : false"
                                    v-if="form.id>0 && form.status!='ARCHIVED' && userRole=='ADMINISTRATOR'"
                                    class="q-pa-md"
                                >
                                    <q-item-section thumbnail class="q-px-md">
                                        <q-icon name="publish" size="xs" />
                                    </q-item-section>
                                    <q-item-section>Forcer publier</q-item-section>
                                </q-item>
                                
                                <q-separator v-if="form.id > 0 && form.status != 'ARCHIVED' && (userRole == 'ADMINISTRATOR')"></q-separator>

                                <q-item clickable
                                    v-if="form.id > 0 && form.status != 'ARCHIVED' && (userRole == 'ADMINISTRATOR')"
                                    @click="$eventBus.$emit('duplicate-project', form)" 
                                    class="q-pa-md"
                                    v-close-popup
                                >
                                    <q-item-section thumbnail class="q-px-md">
                                        <q-icon color="" name="content_copy" size="xs" />
                                    </q-item-section>
                                    <q-item-section style="">Dupliquer le projet</q-item-section>
                                </q-item>


                                <q-separator v-if="form.id > 0 && form.status != 'ARCHIVED' && userRole == 'ADMINISTRATOR'" />


                                <q-item clickable
                                    v-if="form.id > 0 && form.status != 'ARCHIVED' && (userRole == 'ADMINISTRATOR' || form.status == 'NEWPROJECT')"
                                    @click="confirmArchive = true" class="q-pa-md">
                                    <q-item-section thumbnail class="q-px-md">
                                        <q-icon color="red" name="archive" size="xs" />
                                    </q-item-section>
                                    <q-item-section style="color:red">Archiver le projet</q-item-section>
                                </q-item>

                            </div>
                        </q-list>
                    </q-menu>
                </q-btn>


            </div>
            <div class="o-col w-1/2" style="text-align: right">
                <q-btn
                    class="q-mr-md"
                    color="white"
                    text-color="blue"
                    icon-right="send"
                    size="sm"
                    rounded
                    no-caps
                    label="Envoyer les notifications"
                    v-if="form.id>0 && form.hasNotificationsReady && !gotModified && userRole=='ADMINISTRATOR' && 1==2"
                    @click="sendProjectNotifications(form)"
                />
                <q-btn
                    class="q-mr-md"
                    color="green"
                    text-color="white"
                    icon-right="people"
                    size="sm"
                    rounded
                    no-caps
                    label="À planifier"
                    v-if="form.id>0 && form.status=='NEWPROJECT'"
                    @click="toPlanProject(form)"
                />
                <q-btn
                    class="q-mr-md"
                    color="green"
                    text-color="white"
                    icon-right="publish"
                    size="sm"
                    rounded
                    no-caps
                    label="Publier"
                    v-if="form.id>0 && userRole=='ADMINISTRATOR' && form.status!='ARCHIVED'"
                    @click="publishShifts(form)"
                    :disable="(form.status=='DRAFT' || form.status=='HASDRAFT' || form.hasUnpublishedShift || hasUnpublishedResource ) && !gotModified && !apolloLoading ? false : true"
                />
                <!-- form.status : {{  form.status }} - form.hasUnpublishedShift : {{ form.hasUnpublishedShift }} - gotModified : {{ gotModified }} - apolloLoading : {{ apolloLoading }} -->
                <!-- <q-btn
                    no-caps
                    label="Publier"
                    v-if="form.id>0"
                    @click="publishShifts(form)"
                    :disable="(form.hasDrafts || form.draftShifts.length!=form.shifts.length) && !gotModified ? false : true"
                /> -->
                <q-btn
                    color="blue"
                    text-color="white"
                    icon-right="save"
                    size="sm"
                    rounded
                    no-caps
                    label="Sauvegarder"
                    v-if="form.id>0 && form.status!='ARCHIVED'"
                    @click="saveProject(form)"
                    :disable="gotModified ? false : true"
                />

                <q-btn
                    color="blue"
                    text-color="white"
                    icon-right="save"
                    size="sm"
                    rounded
                    no-caps
                    label="Ajouter"
                    v-if="form.id<=0 && form.status!='ARCHIVED'"
                    @click="saveProject(form)"
                />
                <q-btn
                    color="blue"
                    text-color="white"
                    icon-right="save"
                    size="sm"
                    rounded
                    no-caps
                    label="Dupliquer"
                    v-if="form.duplication"
                    @click="saveProject(form)"
                />
            </div>
            <q-dialog v-model="confirmArchive">
                <q-card>
                    <q-card-section class="row items-top" style="flex-wrap: nowrap;">
                        <q-avatar class="q-mt-md" icon="archive" color="primary" text-color="white" />
                        <q-card-section class="column items-left" style="flex-wrap: nowrap;">
                            <span class="text-h6">Attention, êtes vous certain de vouloir archiver le projet «{{ form.name }}».</span>
                        </q-card-section>
                    </q-card-section>

                    <q-card-actions align="right">
                        <q-btn flat label="Annuler" no-caps color="grey" v-close-popup />
                        <q-btn flat label="Archiver" no-caps  color="primary" v-close-popup @click="archiveProject(form)" />
                    </q-card-actions>
                </q-card>
            </q-dialog>
            <q-dialog v-model="confirmDelete">
                <q-card>
                    <q-card-section class="row items-top" style="flex-wrap: nowrap;">
                        <q-avatar class="q-mt-md" icon="delete" color="red" text-color="white" />
                        <q-card-section class="column items-left" style="flex-wrap: nowrap;">
                            <span class="text-h6 red">Attention, êtes vous certain de vouloir supprimer définitivement le projet «{{ form.name }}».</span>
                            <span class="red q-mt-md">Cette action est irréversible.</span>
                        </q-card-section>
                    </q-card-section>

                    <q-card-actions align="right">
                        <q-btn flat label="Annuler" no-caps color="grey" v-close-popup />
                        <q-btn flat label="Supprimer" no-caps  color="primary" v-close-popup @click="deleteProject(form)" />
                    </q-card-actions>
                </q-card>
            </q-dialog>
        </div>
    </q-form>
</template>

<script>
    import { ARCHIVEPROJECT, DELETEPROJECT, UPSERTPROJECT, CREATEDRAFTSHIFTS, CREATEDRAFTSHIFTSDEBUG, PUBLISHSHIFTS, SENDPROJECTNOTIFICATIONS, SENDPARTNERPROJECTNOTIFICATIONS } from "@/graphql/project/mutations";
    import { ASSIGNMENTSERRORS } from "@/graphql/assignment/queries";
    import { DETECTABSENCEERRORS } from '@/graphql/user/mutations'
    import { remove__typename, keepID, removeNULL } from "@/js/utilities";
    import { v4 as uuidv4 } from 'uuid';
    import { PROFESSIONS, COURSES, SKILLS } from '@/graphql/tag/queries'
    import { PROJECTCATEGORIES } from '@/graphql/category/queries'
    import {getWeeksLimits} from '@/js/dateUtilities'
    import uniqBy from 'lodash/uniqBy'
    import orderBy from "lodash/orderBy";
    import { MYPROFILE } from '@/graphql/user/queries'
    import Notifications from '@/components/notifications/Notifications'
    import { UPDATEPROJECTINTERNALNOTES } from '@/graphql/project/mutations'



    export default {
        name: 'ProjectForm',
        components: {
            Notifications
        },
        props: {
            weekrange:{
                type: Object,
                default(){
                    let weekrange=getWeeksLimits(new Date(), this.$generalSettings.settings.firstDayOfWeek);
                    return {
                        ...weekrange
                    }
                }
            },
            project:{
                type: Object,
                default(){
                    return {
                        id: 0,
                        start_date: this.weekrange.str.from,
                        end_date: this.weekrange.str.to,
                        projectManager: null,
                        projectShifts: new Array(),
                        name: ''
                    }
                },
            },
            projectDetailsVisible: {
                type: [Boolean, Number],
                default: true
            },
            shiftOverride:{
                type: Object,
                default: null
            },
            showProjectsShifts: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                userRole: 'MANAGER',
                initialProject: '',
                projectManagerRoles: {role: ["MANAGER", "ADMINISTRATOR"]},
                showShiftTemplatesList: false,
                selectedProjectShift: null,
                form: null,
                model: null,
                professions: null,
                projectHistory: [],
                options: [
                    'Google', 'Facebook', 'Twitter', 'Apple', 'Oracle'
                ],
                historyPage: 1,
                historyHasMore: false,
                historyObserverInit: false,
                historyScrollTo: {},
                newProject: {
                    type: Boolean,
                    default: false,
                },
                apolloLoading: false,
                confirmArchive: false,
                confirmDelete: false,
                projectShiftWithError: {},
                currentTab: 'inbox',
                // projectShiftWithUnassigned: {},
                projectAssignmentWithError: {},
                isValid: true,
                saveTrottle: null,
                updating: false,
                projectShiftTabs: 'projectShiftTabs',
                assignmentsTabs: 'assignments',
                projectTabs: 'projectTabs',
                // hasUnpublishedResource: false,
                // availableStaffVehicules: [],
                orderBySort: 'ASC',
            }
        },
        mounted : function(){
            // this.initialProject=JSON.stringify(remove__typename(this.project))
            let project=JSON.parse(JSON.stringify(this.project))
            // project.projectShifts.sort((a,b) => a.id - b.id); // b - a for reverse sort

            this.initialProject=JSON.stringify(remove__typename(JSON.parse(JSON.stringify(project))))
            this.form=JSON.parse(this.initialProject);

            // if(this.form.projectShifts) this.form.projectShifts = orderBy(this.form.projectShifts, [item => item.name.toLowerCase()])

            setTimeout(function(){
                this.$refs.projectForm.$el.classList.value = this.$refs.projectForm.$el.classList.value + ' is-visible'
            }.bind(this), 100)

            this.$parent.$on('create-shift-override', function(event){
                this.createShiftOverride(event)
            }.bind(this));
            if(this.shiftOverride) this.createShiftOverride(this.shiftOverride)


            if(this.form.id>0) this.getProjectAssignmentsErrors(this.form.id);
        },
        beforeDestroy() {
            this.$parent.$off('create-shift-override')
        },
        watch : {
            projectDetailsVisible: function () {
                if (this.projectDetailsVisible == true) {
                    if(!this.$refs.projectForm.$el.classList.includes('is-visible')) this.$refs.projectForm.$el.classList.add('is-visible')
                } else {
                    this.$refs.projectForm.$el.classList.remove('is-visible')
                }
            },
        },
        computed: {

            selectedProjectShiftResourceCount() {
                let count = 0

                if(this.selectedProjectShift.resouces?.length) count = this.selectedProjectShift.resouces.length
                if(this.selectedProjectShift.staffVehicules?.length) count = this.selectedProjectShift.staffVehicules.length

                return count
            },

            hasUnpublishedResource(){
                let hasUnpublishedResource = false;

                if (!this.$generalSettings.settings.enableResourceModule) return false;

                hasUnpublishedResource = this.form.projectShifts.some(function(projectShift){
                    return projectShift.resources && projectShift.resources.some(function(resource){
                        return (resource.pivot) ? resource.pivot.hasDraft : true
                    })
                })
                
                return hasUnpublishedResource;
            },
            draftNeedSave(){
                let hasUnsavedDraftResource = false;

                if (!this.$generalSettings.settings.enableResourceModule) return false;

                hasUnsavedDraftResource = this.form.projectShifts.some(function(projectShift){
                    return projectShift.resources && projectShift.resources.some(function(resource){
                        return (resource.pivot) ? resource.pivot.draftNeedSave : true
                    })
                })
                
                return hasUnsavedDraftResource;
            },

            availableStaffVehicules(){
                let availableStaffVehicules = [];
                if(this.selectedProjectShift){
                    this.selectedProjectShift.projectAssignments.forEach(function (assignment) {
                        if (assignment.assignedTo && assignment.assignedTo.vehicule_available && assignment.assignedTo.vehicules.length > 0) {
                            assignment.assignedTo.vehicules.forEach(function (vehicule) {
                                // vehicule.name=assignment.assignedTo.name + ' : ' + vehicule.name;
                                availableStaffVehicules.push(vehicule);
                            })
                        }
                    })

                }
                return availableStaffVehicules;
            },

            accommodationErrors(){
                let accommodationErrors = {
                    errorCount: 0,
                    sucessCount: 0
                }

                if (this.selectedProjectShift && this.selectedProjectShift.accommodations && (this.selectedProjectShift.accommodations.length || this.selectedProjectShift.accommodations.id)) {
                    this.selectedProjectShift.projectAssignments.forEach(item => {
                        if (!item.assignedTo) return;
                        if (!item.accommodation_not_required && (!item.accommodation_room_number || item.accommodation_room_number == '')) {
                            accommodationErrors.errorCount++
                        } else if (!item.accommodation_not_required) {
                            accommodationErrors.sucessCount++
                        }
    
                    })
                }

                return accommodationErrors;
            },
            accessLevel(){
                return {
                    isReadOnly: this.userRole!="ADMINISTRATOR" && (this.form.status!="NEWPROJECT" && this.form.status!="TOPLAN"),
                    isLimited: this.userRole!="ADMINISTRATOR"
                }
            },
            projectShiftWithUnassigned(){
                let projectShiftWithUnassigned={}
                if(!this.form.projectShifts) return projectShiftWithUnassigned;
                this.form.projectShifts.forEach(function(item){
                    item.projectAssignments.forEach(function(assignment){
                        if(!assignment.assignedTo){
                            projectShiftWithUnassigned[item.id]=true
                        }
                    }.bind(this))
                }.bind(this))
                return projectShiftWithUnassigned;
            },
            projectShifts(){
                if (!this.form.projectShifts) return [];
                let projectShifts = this.form.projectShifts;
                projectShifts = orderBy(projectShifts, [item => item.dates[0].from ? item.dates[0].from + ' ' + item.start_time + ' ' + item.end_time : item.dates[0] ? item.dates[0] + ' ' + item.start_time + ' ' + item.end_time : ''], [this.orderBySort.toString().toLowerCase()]);

                return projectShifts;
                // return orderBy(this.form.projectShifts, [item => item.name.toLowerCase()])
            },
            gotModified() {

                if (this.draftNeedSave) return true
                let project=JSON.parse(JSON.stringify(this.form));
                // project.projectShifts.sort((a,b) => a.id - b.id); // b - a for reverse sort

                project.projectShifts.forEach(function(projectShift, PSindex){
                    if(projectShift.dates){
                        projectShift.dates.forEach(function(date, DTindex){
                            if(!date.from){
                                project.projectShifts[PSindex].dates[DTindex]={from: date, to: date};
                            }
                        })
                    }
                })
                return JSON.stringify(project) != this.initialProject && !this.updating
            },
            bestCandidateVariables(){
                let tags = [];
                // let skills = [];
                let daysOfWeek = [];
                let dates = [];
                if(this.selectedProjectShift){
                    if(this.selectedProjectShift.Sun) daysOfWeek.push(0)
                    if(this.selectedProjectShift.Mon) daysOfWeek.push(1)
                    if(this.selectedProjectShift.Tue) daysOfWeek.push(2)
                    if(this.selectedProjectShift.Wed) daysOfWeek.push(3)
                    if(this.selectedProjectShift.Thu) daysOfWeek.push(4)
                    if(this.selectedProjectShift.Fri) daysOfWeek.push(5)
                    if(this.selectedProjectShift.Sat) daysOfWeek.push(6)
                    if(this.selectedProjectShift.dates){
                        this.selectedProjectShift.dates.forEach(function(date){
                            if(!date.from){
                                dates.push({from: date, to: date})
                            }else{
                                dates.push(date)
                            }
                        })
                    }

                    if(this.selectedProjectShift.courses){
                        this.selectedProjectShift.courses.forEach(function(course){
                            tags.push(course.id);
                        })
                    }
                    if(this.selectedProjectShift.skills){
                        this.selectedProjectShift.skills.forEach(function(skill){
                            tags.push(skill.id);
                        })
                    }
                }
                let excludedUsers=[];
                this.selectedProjectShift.projectAssignments.forEach(function(assignment){
                    if(assignment.assignedTo) excludedUsers.push(assignment.assignedTo.id)
                })

                let excludedResources=[];
                if(this.selectedProjectShift.resources){
                    this.selectedProjectShift.resources.forEach(function(resource){
                        excludedResources.push(resource.id)
                    })
                }
                return {tags: tags, excludedUsers: excludedUsers, daysOfWeek: daysOfWeek, dates: dates, excludedResources: excludedResources };
            },
            minMaxDates(){
                if(!this.form.projectShifts) return {min: null, max: null}
                let dates=[];
                this.form.projectShifts.forEach(function(projectShift){
                    if(projectShift.dates){
                        projectShift.dates.forEach(function(date){
                            if(date.from) dates.push(date.from);
                            if(date.to) dates.push(date.to);
                            if(typeof date === 'string') dates.push(date);
                        })
                    }
                })
                dates.sort();
                if(dates.length>0){
                    this.setProjectDates({
                        min: dates[0],
                        max: dates[dates.length-1]
                    })
                    return {
                        min: dates[0],
                        max: dates[dates.length-1]
                    }
                }
                return {min: null, max: null}
            },
            customerVariables(){
                let variables={ first: 15 };
                if(this.form.customers){
                    let items=Object.assign(this.form.customers);
                    if( !Array.isArray(items) ) items=[items];
                    if(items.length) variables.customer_ids=[];
                    items.forEach(function(item){
                        variables.customer_ids.push(item.id)
                    })
                }
                return variables
            },
            customTagsList(){
                let customTagsList=[], lastLabel='', lastItem={};
                if (!this.form.customtags) return customTagsList;
                
                orderBy(this.form.customtags, [item => (item.label) ? item.label.name.toLowerCase() : ""]).forEach(function (item) {

                    let label = 'sans catégorie';
                    if (item.label?.name) label = item.label.name;

                    if (lastLabel != label){
                        lastItem={
                            label: label,
                            tags: []
                        }
                        lastItem.tags.push(item)
                        customTagsList.push(lastItem)
                    }else{
                        lastItem.tags.push(item)
                    }
                    
                    lastLabel = label
                })
                return customTagsList;
            }
        },
        methods: {

            updateResource(event) {
                if (event.old.isUserVehicule) {
                    this.selectedProjectShift.staffVehicules = this.selectedProjectShift.staffVehicules.filter(obj => obj.id !== event.old.id)
                } else {
                    this.selectedProjectShift.resources = this.selectedProjectShift.resources.filter(obj => obj.id !== event.old.id)
                }

                if (event.new.isUserVehicule) {
                    this.selectedProjectShift.staffVehicules.push(event.new)
                } else {
                    this.selectedProjectShift.resources.push(event.new)
                }
            },

            addResource(resource) {
                if (resource.isUserVehicule) {
                    this.selectedProjectShift.staffVehicules.push(resource)
                    this.selectedProjectShift.staffVehicules = uniqBy(this.selectedProjectShift.staffVehicules, "id")
                } else {
                    this.selectedProjectShift.resources.push(resource)
                    this.selectedProjectShift.resources = uniqBy(this.selectedProjectShift.resources, "id")
                }
            },

            removeResource(item) {
                if(!this.selectedProjectShift) return;
                if (item.isUserVehicule) {
                    this.selectedProjectShift.staffVehicules = this.selectedProjectShift.staffVehicules.filter(obj => obj.id !== item.id)
                } else {
                    this.selectedProjectShift.resources = this.selectedProjectShift.resources.filter(obj => obj.id !== item.id)
                }
            },


            duplicateProject() {
                this.form.id = 0
            },

            saveInternalNotes(internal_notes) {

                clearTimeout(this.saveTrottle)
                if(internal_notes == null) internal_notes=''

                this.saveTrottle = setTimeout(function () {

                    this.form.internal_notes = internal_notes
                    if(!this.$generalSettings.settings.projectInternalNotesAutoSave) return

                    this.updating = true;

                    this.$apollo.mutate({
                        mutation: UPDATEPROJECTINTERNALNOTES,
                        variables: {
                            projectID: this.project.id,
                            internalNote: internal_notes
                        }
                    }).then((data) => {
                        this.$q.notify({ timeout: 500, type: 'positive', message: "Note interne sauvegardée" })

                        let initialProject = JSON.parse(this.initialProject)
                        initialProject.internal_notes = data.data.updateProjectInternalNotes.internal_notes
                        this.initialProject = JSON.stringify(initialProject)

                        this.updating = false;

                    }).catch(e => {
                        if (e.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: e.message })
                        this.updating = false;
                    })

                }.bind(this), 500)
            },

        
            getProjectAssignmentsErrors(projectID){
                this.$apollo.query({
                    query: ASSIGNMENTSERRORS,
                    fetchPolicy: 'network-only',
                    variables: {projectID: projectID},
                }).then((data) => {
                    this.projectShiftWithError={};
                    this.projectAssignmentWithError={};
                    data.data.assignmentErrors.forEach(function(error){
                        if(error.assignmentAbsence) {
                            error.assignments=[];
                            error.assignments.push(error.assignmentAbsence)
                        }
                        if(error.resourceUnavailibility) {
                            error.resourceAssignments=[];
                            error.resourceAssignments.push(error.resourceUnavailibility)
                        }
                        if(error.assignments.length>0){
                            error.assignments.forEach(function(assignment){
                                this.$set(this.projectShiftWithError, assignment.project_shift_id, true)
                                this.$set(this.projectAssignmentWithError, assignment.project_assignment_id, { user_profile_id: assignment.user_profile_id, type: error.type })
                            }.bind(this))
                        }else if(error.draftAssignments.length>0){
                            error.draftAssignments.forEach(function(assignment){
                                this.$set(this.projectShiftWithError, assignment.project_shift_id, true)
                                this.$set(this.projectAssignmentWithError, assignment.project_assignment_id, { user_profile_id: assignment.user_profile_id, type: error.type })
                            }.bind(this))
                        }

                        if (this.$generalSettings.settings.enableResourceModule && error.resourceAssignments.length > 0) {
                            error.resourceAssignments.forEach(function (assignment) {
                                this.$set(this.projectShiftWithError, ('resource' + assignment.project_shift_id), true)
                                this.$set(this.projectAssignmentWithError, (assignment.project_shift_id+'-'+assignment.resource_id), { project_shift_id: assignment.project_shift_id, resource_id: assignment.resource_id, type: error.type })
                            }.bind(this))
                        }else if (error.draftResourceAssignments.length > 0) {
                            error.draftResourceAssignments.forEach(function (assignment) {
                                this.$set(this.projectShiftWithError, ('resource' + assignment.project_shift_id), true)
                                this.$set(this.projectAssignmentWithError, (assignment.project_shift_id + '-' + assignment.resource_id), { project_shift_id: assignment.project_shift_id, resource_id: assignment.resource_id, type: error.type })
                            }.bind(this))
                        }
                    }.bind(this))

                })
            },
            addProjectCustomTag(item){
                this.form.customtags.push(item)
                this.form.customtags=uniqBy(this.form.customtags, 'id')
            },
            removeProjectCustomTag(item){
                this.form.customtags=this.form.customtags.filter(obj => obj.id !== item.id)
            },
            setSelectedProjectShift(projectShiftID){
                this.form.projectShifts.forEach(function(projectShift){
                    if(projectShift.id==projectShiftID) this.selectedProjectShift=projectShift
                }.bind(this))
            },
            setProjectDates(values){
                this.form.start_date=values.min;
                this.form.end_date=values.max;
            },
            toggleSelectedShift(item){
                if(this.selectedProjectShift && this.selectedProjectShift.id==item.id){
                    this.selectedProjectShift=null
                }else{
                    this.selectedProjectShift=item
                }
            },
            setNewProjectShift(item){
                item.id='newProjectShift-' + uuidv4();
                // item.id=0;
                item.isNew=true;
                this.showShiftTemplatesList=false;
                this.form.projectShifts=this.form.projectShifts.concat([item]);
                this.selectedProjectShift=item;
            },
            duplicateProjectShift(item){
                let duplicatedProjectShift=JSON.parse(JSON.stringify(remove__typename(item)));

                // duplicatedProjectShift.id=uuidv4();
                duplicatedProjectShift.id='duplicatedProjectShift-' + uuidv4();
                duplicatedProjectShift.isNew=true;
                duplicatedProjectShift.dates=[];
                duplicatedProjectShift.name+=" copy";
                duplicatedProjectShift.projectAssignments.forEach(function(item){
                    // delete item.id;
                    item.id='duplicatedProjectAssignment-' + uuidv4();
                    // item.id="duplicatedProjectAssignment";
                })

                this.form.projectShifts.push(duplicatedProjectShift)

            },
            createShiftOverride(src){
                this.form.projectShifts.forEach(function(item){
                    if(item.id==src.project_shift_id){
                        let newItem=JSON.parse(JSON.stringify(item));
                        // newItem.name+=" *";
                        newItem.dates=[src.date];
                        newItem.id='overrideProjectShift-' + uuidv4();
                        // newItem.id='overrideProjectShift';
                        newItem.isNew=true;
                        newItem.projectAssignments.forEach(function(item){
                            // delete item.id;
                            item.id='overrideProjectAssignment-' + uuidv4();
                            // item.id="overrideProjectAssignment";
                        })
                        newItem.isProjectShiftOverwriter=item.id;
                        this.form.projectShifts.push(newItem)
                        this.selectedProjectShift=newItem;

                    }
                }.bind(this))
                if(this.$parent.shiftOverride) this.$parent.shiftOverride=null;
                // this.form.projectShifts.concat([newShift]);
            },
            setAssignmentsCount(event){
                let item=JSON.parse(JSON.stringify(event.profession)), value=parseInt(event.value), i;
                if(value>0){
                    for(i=0; i<value; i++){
                        this.addAssignement(item)
                    }
                }else if(value<0){
                    value=Math.abs(value)
                    let unassigned=this.selectedProjectShift.projectAssignments.filter(obj => !obj.assignedTo && obj.profession.id==item.id )
                    // let assigned=this.selectedProjectShift.projectAssignments.filter(obj => obj.assignedTo && obj.profession.id==item.id )
                    unassigned.forEach(function(item){
                        if(value>0){
                            this.removeAssignment(item);
                            value--;
                        }
                    }.bind(this))
                }
            },
            addAssignement(item){
                if(!this.selectedProjectShift.projectAssignments) this.selectedProjectShift.projectAssignments=new Array();
                let newAssignment={
                    id: 'newProjectAssignment-' + uuidv4(),
                    // id: 'newProjectAssignment',
                    assignedTo: null,
                    profession: {
                        id: item.id,
                        name: item.name
                    }
                }
                this.selectedProjectShift.projectAssignments.push(newAssignment)
            },
            addTagVariant(item, on){
                if(!this.selectedProjectShift[on]) this.selectedProjectShift[on]=new Array();
                if(!this.selectedProjectShift[on].includes(item)){
                    this.selectedProjectShift[on].push(item)
                }
            },
            unassign(assignment){
                this.selectedProjectShift.staffVehicules=this.selectedProjectShift.staffVehicules.filter(obj => obj.userProfile.id !== assignment.assignedTo.id)
                assignment.assignedTo=null;
            },
            removeAssignment(item) {
                // return
                if (item.assignedTo?.id) {
                    this.selectedProjectShift.staffVehicules=this.selectedProjectShift.staffVehicules.filter(obj => obj.userProfile.id !== item.assignedTo.id)
                }

                this.selectedProjectShift.projectAssignments=this.selectedProjectShift.projectAssignments.filter(obj => obj.id !== item.id)

                if(!this.selectedProjectShift.disconnectProjectAssignments) this.selectedProjectShift.disconnectProjectAssignments=[];
                if(item.id) this.selectedProjectShift.disconnectProjectAssignments.push(item.id);
            },
            removeProjectShift(item){
                this.form.projectShifts=this.form.projectShifts.filter(obj => obj.id !== item.id)
                if(!this.form.deleteProjectShifts) this.form.deleteProjectShifts=[];
                this.form.deleteProjectShifts.push(item.id)

                if(this.selectedProjectShift) this.selectedProjectShift.id=-1;
            },
            detectAbsenceErrors(projectID){
                this.$q.notify({ timeout: 0, progress: false, spinner: true, message: "Détection d'erreurs d'absences en cours..."})
                this.$apollo.mutate({
                    mutation: DETECTABSENCEERRORS,
                    variables: {
                        projectID: projectID
                    }
                }).then((data) => {
                    this.$q.notify({type: 'positive', message: "Détection d'erreurs d'absences complétée"})
                    this.$eventBus.$emit('refresh-notifications', this.form.id);
                    if(data.data.detectAbsenceErrors.length>0) this.$emit('refresh-project', projectID);
                    if(this.$refs.HistoryPanel) this.$refs.HistoryPanel.refreshList();
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                    this.getProjectAssignmentsErrors(projectID)
                })
            },
            createDraftShifts(project, dateRange, debug = false) {

                let mutation = CREATEDRAFTSHIFTS;
                if(debug) mutation = CREATEDRAFTSHIFTSDEBUG;
                if(!project || this.userRole!="ADMINISTRATOR") return;
                this.$q.notify({ timeout: 0, progress: false, spinner: true, message: "Projet : "+project.name, caption: "Création des brouillons de quarts de travail en cours..."})
                this.$apollo.mutate({
                    mutation: mutation,
                    variables: { projectID: project.id, shiftsDateRange: dateRange },
                }).then((data) => {
                    if(this.newProject) this.$emit('refetch-projects', data.data.createDraftShifts);
                    this.initialProject=JSON.stringify(remove__typename(JSON.parse(JSON.stringify(data.data.createDraftShifts))))
                    // this.initialProject=JSON.stringify(remove__typename(data.data.createDraftShifts))
                    this.form=JSON.parse(this.initialProject);

                    if(this.selectedProjectShift) this.setSelectedProjectShift(this.selectedProjectShift.id)

                    this.$q.notify({ type: 'positive', message: project.name, caption: "Création des brouillons de quarts de travail terminée"})
                    this.detectAbsenceErrors(this.form.id)
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                }).finally(() => {
                    this.apolloLoading=false;
                })
            },
            publishShifts(project){
                if(!project || this.userRole!="ADMINISTRATOR") return;
                this.$q.notify({ timeout: 0, progress: false, spinner: true, message: "Projet : "+project.name, caption: "Publication des quarts de travail en cours..."})

                this.apolloLoading=true;
                this.$apollo.mutate({
                    mutation: PUBLISHSHIFTS,
                    variables: { projectID: project.id, shiftsDateRange: this.weekrange.str },
                }).then((data) => {
                    if(this.newProject) this.$emit('refetch-projects', data.data.publishShifts);
                    // this.initialProject=JSON.stringify(remove__typename(data.data.publishShifts))
                    this.initialProject=JSON.stringify(remove__typename(JSON.parse(JSON.stringify(data.data.publishShifts))))

                    this.form=JSON.parse(this.initialProject);
                    if(this.selectedProjectShift) this.setSelectedProjectShift(this.selectedProjectShift.id)

                    this.$q.notify({type: 'positive', message: project.name, caption: "Publication des quarts de travail terminée"})
                    this.detectAbsenceErrors(this.form.id)
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                }).finally(() => {
                    this.apolloLoading=false;
                })
            },
            sendProjectNotifications(project){
                if(!project) return;
                this.$q.notify({ spinner: true, message: "Projet : "+project.name, caption: "Envoi des notifications en cours"})
                this.$apollo.mutate({
                    mutation: SENDPROJECTNOTIFICATIONS,
                    variables: { projectID: project.id, shiftsDateRange: this.weekrange.str },
                }).then((data) => {
                    // this.initialProject=JSON.stringify(remove__typename(data.data.sendProjectNotifications))
                    this.initialProject=JSON.stringify(remove__typename(JSON.parse(JSON.stringify(data.data.sendProjectNotifications))))
                    this.form=JSON.parse(this.initialProject);
                    if(this.selectedProjectShift) this.setSelectedProjectShift(this.selectedProjectShift.id)

                    if(this.$refs.HistoryPanel) this.$refs.HistoryPanel.refreshList();
                    this.$q.notify({type: 'positive', message: project.name, caption: "Envoi des notifications terminée"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                }).finally(() => {
                })
            },
            sendPartnerProjectNotifications(project){
                if(!project) return;
                this.$q.notify({ spinner: true, message: "Projet : "+project.name, caption: "Envoi des notifications en cours"})
                this.$apollo.mutate({
                    mutation: SENDPARTNERPROJECTNOTIFICATIONS,
                    variables: { projectID: project.id, shiftsDateRange: this.weekrange.str },
                }).then((data) => {
                    // this.initialProject=JSON.stringify(remove__typename(data.data.sendProjectNotifications))
                    this.initialProject = JSON.stringify(remove__typename(JSON.parse(JSON.stringify(data.data.sendPartnerProjectNotifications))))
                    this.form=JSON.parse(this.initialProject);
                    if(this.selectedProjectShift) this.setSelectedProjectShift(this.selectedProjectShift.id)

                    if(this.$refs.HistoryPanel) this.$refs.HistoryPanel.refreshList();
                    this.$q.notify({type: 'positive', message: project.name, caption: "Envoi des notifications terminée"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                }).finally(() => {
                })
            },
            revertProject(){
                this.form=JSON.parse(this.initialProject);
                if(this.selectedProjectShift) this.setSelectedProjectShift(this.selectedProjectShift.id)
            },
            archiveProject(form){
                this.$apollo.mutate({
                    mutation: ARCHIVEPROJECT,
                    variables: { projectID: form.id, shiftsDateRange: this.weekrange.str },
                    update: (store, { data: { archiveProject } }) => {
                        // this.initialProject=JSON.stringify(remove__typename())
                        this.initialProject=JSON.stringify(remove__typename(JSON.parse(JSON.stringify(archiveProject))))
                        this.form=JSON.parse(this.initialProject);
                        if(this.selectedProjectShift && this.selectedProjectShift.isNew){
                            this.selectedProjectShift=null
                        }
                        if(this.selectedProjectShift) this.setSelectedProjectShift(this.selectedProjectShift.id)
                    }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Projet : "+form.name, caption: "Informations sauvegardées"})
                    this.$emit('cancel'); //close form
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                    this.apolloLoading=false;
                }).finally(() => {
                    this.$eventBus.$emit('refresh-notifications', this.form.id);
                    this.apolloLoading=false;
                })
            },
            deleteProject(form){
                this.$apollo.mutate({
                    mutation: DELETEPROJECT,
                    variables: { projectID: form.id, shiftsDateRange: this.weekrange.str },
                    // update: (store, { data: { deleteProject } }) => {
                    //     this.initialProject=JSON.stringify(remove__typename(deleteProject))
                    //     this.form=JSON.parse(this.initialProject);
                    //     if(this.selectedProjectShift && this.selectedProjectShift.isNew){
                    //         this.selectedProjectShift=null
                    //     }
                    //     if(this.selectedProjectShift) this.setSelectedProjectShift(this.selectedProjectShift.id)
                    // }
                }).then((data) => {
                    this.$q.notify({type: 'positive', message: "Projet : "+form.name, caption: "Informations sauvegardées"})
                    this.$emit('deleted-projects', data.data.deleteProject);
                    this.$emit('cancel'); //close form
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                    this.apolloLoading=false;
                }).finally(() => {
                    this.$eventBus.$emit('refresh-notifications', this.form.id);
                    this.apolloLoading=false;
                })
            },
            toPlanProject(form){
                form.projectStatus="TOPLAN";
                this.saveProject(form);
            },
            async saveProject(form, debug=false){

                let validation = this.isValid = await this.$refs.projectForm.validate() && this.projectShifts.length
                if(!validation){
                    this.$q.notify({type: 'negative', message: "Informations non savegardées", caption: "Certains champs requis n'ont pas été remplis"});
                    return false;
                }
                this.$q.notify({ timeout: 0, progress: false, spinner: true, message: "Projet : "+form.name, caption: "Sauvegarde du projet en cours..."})

                let project=JSON.parse(JSON.stringify(form)); // Object.assign({}, form);

                if(project.internal_notes === null) delete project.internal_notes

                if(project.shifts) delete project.shifts;
                if(project.draftShifts) delete project.draftShifts;
                if(project.assignmentsSummary) delete project.assignmentsSummary;
                
                if(project.projectManager){
                    project.projectManager=project.projectManager.id;
                }else{
                    project.disconnectProjectManager=true;
                }
                if(project.supervisor){
                    project.supervisor=project.supervisor.id;
                }else{
                    project.disconnectSupervisor=true;
                }
                if(project.customers){
                    project.customers=project.customers.map(obj => obj.id);
                }else{
                    project.customers=new Array();
                }
                if(project.projectCategories){
                    project.projectCategories=project.projectCategories.map(obj => obj.id);
                }else{
                    project.projectCategories=new Array();
                }
                if(project.contacts){
                    project.contacts=project.contacts.map(obj => obj.id);
                }else{
                    project.contacts=new Array();
                }
                if(project.locations){
                    project.locations=project.locations.map(obj => obj.id);
                }else{
                    project.locations=new Array();
                }

                project.tags=[];
                project.customtags.forEach(function(item){
                    project.tags.push(item.id)
                })
                project.projectShifts=keepID(project.projectShifts, 'assignedTo');
                project.projectShifts=keepID(project.projectShifts, 'profession');
                project.projectShifts=keepID(project.projectShifts, 'courses');
                project.projectShifts=keepID(project.projectShifts, 'skills');
                project.projectShifts.forEach(function(projectShift){
                    projectShift.tags = {};
                    projectShift.tags.sync = [];
                    projectShift.tags.sync=projectShift.tags.sync.concat(projectShift.courses.map(item => item.id), projectShift.skills.map(item => item.id), projectShift.customtags.map(item => item.id))
                    delete projectShift.courses;
                    delete projectShift.customtags;
                    delete projectShift.skills;
                    delete projectShift.hasDraft;

                    projectShift.resources=projectShift.resources.concat(projectShift.staffVehicules)
                    delete projectShift.staffVehicules;
                    let tmpRessources=JSON.parse(JSON.stringify(projectShift.resources));
                    delete projectShift.resources;
                    projectShift.resources =  {};
                    projectShift.resources.sync = [];
                    tmpRessources.forEach(function(item){
                        projectShift.resources.sync.push(item.id)
                    })

                    if(project.id>-1) projectShift.projectID=project.id;
                    if(projectShift.overwrittenProjectShift) delete projectShift.overwrittenProjectShift;

                    // let pss = { supervisor: {} }
                    if (projectShift.supervisor) {
                        let supervisor_id = projectShift.supervisor.id;
                        projectShift.supervisor = {}
                        projectShift.supervisor.connect = supervisor_id

                    } else {
                        projectShift.supervisor = {}
                        projectShift.supervisor.disconnect = true;
                    }
                    if (projectShift.customerContact) {
                        let customerContact_id = projectShift.customerContact.id;
                        projectShift.customerContact = {}
                        projectShift.customerContact.connect = customerContact_id

                    } else {
                        projectShift.customerContact = {}
                        projectShift.customerContact.disconnect = true;
                    }

                    if (projectShift.accommodations) {
                        let ids = null
                        if (!projectShift.accommodations.id && projectShift.accommodations.length) {
                            ids = projectShift.accommodations.map(obj => obj.id)
                        } else if (projectShift.accommodations.id) {
                            ids = [projectShift.accommodations.id]
                        } else {
                            ids = []
                        }
                        projectShift.accommodations = {}
                        projectShift.accommodations.sync = ids
                    } else {
                        projectShift.accommodations = {}
                        projectShift.accommodations.sync = []
                    }

                    // if (project.customers) {
                    //     project.customers = project.customers.map(obj => obj.id);
                    // } else {
                    //     project.customers = new Array();
                    // }


                })


                project.projectShifts.forEach(function(projectShift, PSindex){
                    if(projectShift.opened) delete projectShift.opened
                    if(projectShift.isNew) delete projectShift.isNew
                    if(projectShift.projectAssignments) {
                        projectShift.projectAssignments.forEach(function(item){
                            if(project.id>-1) item.projectID=project.id;
                            if(project.id>-1) item.projectShiftID=projectShift.id;
                            if(!item.assignedTo) item.assignedTo={disconnect:true}
                            delete item.hasDraft;
                        })
                        let temp=JSON.parse(JSON.stringify(projectShift.projectAssignments));
                        delete projectShift.projectAssignments
                        projectShift.projectAssignments={};
                        projectShift.projectAssignments.upsert=Object.assign([], temp);
                    }
                    if(projectShift.disconnectProjectAssignments){
                        projectShift.projectAssignments.delete=Object.assign([], projectShift.disconnectProjectAssignments);
                        delete projectShift.disconnectProjectAssignments;
                    }
                    if(projectShift.dates){
                        projectShift.dates.forEach(function(date, DTindex){
                            if(!date.from){
                                project.projectShifts[PSindex].dates[DTindex]={from: date, to: date};
                            }
                        })
                    }
                })
                let temp=JSON.parse(JSON.stringify(project.projectShifts));
                delete project.projectShifts
                project.projectShifts={}
                project.projectShifts.upsert=Object.assign([], temp);
                if(this.form.deleteProjectShifts) project.projectShifts.delete=Object.assign([], this.form.deleteProjectShifts);
                // delete project.projectShifts.courses;

                // project=remove__typename(project);
                project=remove__typename(removeNULL(project));
                this.apolloLoading=true;
                this.$apollo.mutate({
                    mutation: UPSERTPROJECT,
                    variables: { ...project, shiftsDateRange: this.weekrange.str },
                    update: (store, { data: { upsertProject } }) => {
                        // if(this.newProject) this.$emit('refetch-projects', upsertProject);
                        // this.initialProject=JSON.stringify(remove__typename())
                        this.initialProject=JSON.stringify(remove__typename(JSON.parse(JSON.stringify(upsertProject))))
                        this.form=JSON.parse(this.initialProject);
                        if(this.selectedProjectShift && this.selectedProjectShift.isNew){
                            this.selectedProjectShift=null
                        }
                        if(this.selectedProjectShift) this.setSelectedProjectShift(this.selectedProjectShift.id)
                    }
                }).then((data) => {
                    this.$q.notify({type: 'positive', message: "Projet : "+project.name, caption: "Informations sauvegardées"})
                    // this.initialProject=JSON.stringify(remove__typename(data.data.upsertProject))
                    this.initialProject=JSON.stringify(remove__typename(JSON.parse(JSON.stringify(data.data.upsertProject))))
                    this.form=JSON.parse(this.initialProject);

                    if(this.newProject && this.userRole!="ADMINISTRATOR"){
                        this.$emit('refetch-projects', data.data.upsertProject);
                        return
                    }
                    if (form.duplication) {
                        this.$emit('refetch-project-duplication', data.data.upsertProject);
                        // return
                    }
                    if(!debug){
                        this.createDraftShifts(data.data.upsertProject, this.weekrange.str, debug)
                    }else{
                        this.apolloLoading = false;
                    }
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message});
                    this.apolloLoading=false;
                }).finally(() => {
                })
            },
        },
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-only',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data){
                    this.userRole=data.myProfile.role
                    return data
                }
            },
            projectCategories: {
                query: PROJECTCATEGORIES,
                fetchPolicy: 'cache-first',
                error(error) {
                    if (error.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: error.message });
                },
                update(projectCategories) {
                    return projectCategories;
                }
            },
            professions: {
                query: PROFESSIONS,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(professions) {
                    return professions.professions;
                }
            },
            skills: {
                query: SKILLS,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(skills) {
                    return skills.skills;
                }
            },
            courses: {
                query: COURSES,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(courses) {
                    return courses.courses;
                }
            },
            // attributes: {
            //     query: CUSTOMTAGLABELSTAGS,
            //     fetchPolicy: 'cache-first',
            //     error(error){
            //         if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
            //     },
            //     variables: {
            //         model: "PROJECTS"
            //     },
            //     update(data) {
            //         return data.customTagLabels;
            //     }
            // },
        },
    }
</script>

<style lang="scss">
    @import "@/scss/components/form/Form.scss";
    @import "@/scss/components/form/ProjectForm.scss";

    .c-dashboard-project__inner .q-btn .q-icon {
        margin-top: -3px;
    }
    
    .c-form-tabs {
        .q-tab__label {
            text-transform: none;
            font-size: 0.85rem !important;
        }
    
        .disabled,
        .disabled *,
        [disabled],
        [disabled] * {
            pointer-events: none;
        }
    
        .q-tab {
            padding: 0 10px;
        }

        .q-tab__indicator.absolute-bottom {
            height: 1px;
        }

    }

    .c-assignments-col {
    
        .q-panel.scroll {
            overflow: visible;
        }


        .q-field--auto-height.q-field--dense.q-field--labeled .q-field__control-container {
            padding-top: 8px;
        }

        .q-field.row.no-wrap.items-start.q-ml-auto.q-input.q-field--filled.q-field--labeled.q-field--dense.q-validation-component{
        
            // margin-bottom: -8px;

        }
        .assignments-list{

            .q-input.q-field--borderless {
                margin-bottom: 6px;

                .q-field__control {
                    background: transparent;
                    border-bottom: none;
            
                    &::before {
                        background-color: transparent !important;
                        display: none;
                    }
                    &::after {
                        background-color: transparent !important;
                        display: none;
                    }
            
                    &:hover::before {
                        display: none;
                    }
                }
            }
            
        }


    }
    html body .c-app .c-accommodation .q-field--float .q-field__label {
        transform: translateY(-16px) !important;
    }
</style>
<style scoped lang="scss">
    .icon-btn {
        cursor: pointer;
    }
</style>
